import { initializeApp } from 'firebase/app';
import { signInWithCustomToken, signInWithEmailAndPassword,
 signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo, signInWithCredential, signOut,initializeAuth, browserPopupRedirectResolver,browserLocalPersistence,indexedDBLocalPersistence, } from "firebase/auth";
import { getFirestore, collection, getDocs, doc, setDoc, query, where, addDoc, Timestamp, arrayUnion, arrayRemove } from "firebase/firestore/lite";
import { getFunctions, httpsCallable } from "firebase/functions";
import { setConfig } from './config.js';

export default class bar {

  constructor() {
    this.host = window.location.protocol+'//'+window.location.host+'/';
    this.assine_environment = assine_environment[0];
    this.app = initializeApp(setConfig(this.assine_environment));
    //this.auth = getAuth();
    this.auth = initializeAuth(this.app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
      popupRedirectResolver: browserPopupRedirectResolver,
    });
    this.db = getFirestore();
    this.usersColection = collection(this.db, "users");
    
    this.prefix_amb = "";
    if( this.assine_environment == "sandbox"){
      this.prefix_amb = "homolog_";
    }
    
    this.sessionCookieName = this.prefix_amb + "session";
    
    this.isGaCreated = false;
    this.swgUser = false;
    this.authEndpoint = "https://us-central1-abril-id-testes-1528223718961.cloudfunctions.net/authUtils";
    this.redisAccountedEndpoint = "https://us-central1-abril-id-testes-1528223718961.cloudfunctions.net/addMessageSkp";
    this.redisOpenedTempEndpoint = "https://us-central1-abril-id-testes-1528223718961.cloudfunctions.net/addMessageOpened";
    this.onTapEndPointWp = this.host+"wp-json/login/ontap/v1/verify?eR7DREsd4drewteR7DREsd4drewtyE456ewty76zsE456ewty76edE456ewty76ryE456ewty76zsE456ewty76edE456ewty76ro=";
    this.credencialOneTap = "1087443011751-lbf58cqf1pbe0o2djsnm2nt9j0pqvbt7.apps.googleusercontent.com";
    this.LoginTerraCheckEndPointWp = this.host + "wp-json/login/terra/v1/verify";

    if( this.assine_environment == "sandbox"){
      this.authEndpoint = "https://us-central1-abril-id-homolog.cloudfunctions.net/authUtils";
      this.redisAccountedEndpoint = "https://us-central1-abril-id-homolog.cloudfunctions.net/addMessageSkp";
      this.redisOpenedTempEndpoint = "https://us-central1-abril-id-homolog.cloudfunctions.net/addMessageOpened";
      this.credencialOneTap = "22104083922-nrrktsio7fs30tmvqgo3a5njev87g496.apps.googleusercontent.com";
    }

    if(window.location.href.indexOf("ampsync") > 0){
      return this.syncAmp();
    }

    this.functions = getFunctions();
    this.verifyUser =  httpsCallable(this.functions, 'verifyUser');
    this.userData = {};
    this.codClienteLogin = "";
    this.atualuser = "";
    this.currentAnonymousUser;
    this.currentAnonymousUserId;
    this.localStorage = "";
    this.eventLabel = "";
    this.tipo_paywall = wp_paywall_vars.tipo_paywall;
    //this.dados_de_contabilizacao = wp_paywall_vars.dados_de_contabilizacao;
    this.total_views_accounted = wp_paywall_vars.total_views_accounted;
    this.total_views_accounted_virtual = wp_paywall_vars.total_views_accounted_virtual;
    this.accountedDaysClear = wp_paywall_vars.meteringExpires;
    this.logged_paywall = logged_paywall.toString().split(",");
    this.permission = false;
    this.autenticationFlow = false;
    this.loginAmp = 0;
    this.loginAmpCdn = 0;
    this.readerIdCdn = "";
    this.labelAmp = "";
    this.eventLabel = "";
    this.erroLogin = false;
    this.updateScreen = true;
    this.userState = "";
    this.maxTrail = 3;
    this.crm = null;
    this.indGoogleSubLinking = "N";
    this.indGoogleSwg = "N";
    this.bloqueioVirtual = false;
    this.rrme = false;
    this.ontaptentativas = 0;
    this.forca_logout = false;
    this.forca_paywall_local =  wp_paywall_vars.force_paywall_local == "true" ? true : false;

    if( typeof wp_paywall_vars.rrme !== "undefined" ){
      if( wp_paywall_vars.rrme == "1" ){
        this.rrme = true;
      }
    }
    console.log(this.rrme)
    this.loadedOnboarding = false;

    if( this.tipo_paywall == "closed" ){
      this.eventLabel = "Bloqueio fechado ";
    }

    if( this.tipo_paywall == "accounted" ){
      this.eventLabel = "Bloqueio contabilizado  ";
    }

    this.eventCategoryVivo = '';
    if(document.getElementById("pageLoginVivoFibra") !== null){
      this.userData.tipo_login = "vivo";
      this.eventCategoryVivo = ' - Vivo';
      this.setOrUpdateUserDataStorage({"tipo_login" : "Vivo"});
    }


    if (window.location.href.indexOf("login") > 0) {
      this.loginAmp = this.getParam("loginAmp");
      let tipo_paywall = this.getParam("tipo_paywall");
      let rotulo = "Bloqueio contabilizado ";
      if( tipo_paywall == "closed" ){
        rotulo = "Bloqueio fechado ";
      }

      this.readerIdCdn = this.getParam("ampReaderId");
      if (typeof this.readerIdCdn !== "undefined" && this.readerIdCdn !== "" && this.readerIdCdn !== null) {
        this.loginAmpCdn = 1;
        console.log("CDN "+ this.readerIdCdn);
      }

      if( this.loginAmp === "1" || this.loginAmpCdn == 1){
        this.labelAmp = " - AMP";
        this.sendMetricsGA( 'metric1', 'Paywall', 'Entrada na tela de Login' + this.eventCategoryVivo, rotulo + this.labelAmp );
      }
    }


    this.setlabelEvent();
    this.syncAuth();
    if( !this.hasCrossSession() ){
      //AbrilFirebaseInterface.updateScreen();
    }

    if( customData.activeOntap != "active" ){
      this.execAbrilScripts( "AbrilBundle.startOntap","AbrilBundle.startOntap" );
    }

    if(wp_paywall_vars.is_swg_activated == 1){
      this.startSwG();
      this.checkOntap();
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOntap");
      this.execAbrilScripts( null, "AbrilBundle.startOntap" );
    }else{
      this.execAbrilScripts( "AbrilBundle.startOntap", "AbrilBundle.startOntap" );
    }
    if(wp_paywall_vars.subscription_linking == "1"){
      //this.checkLinking();
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startLinking");
      //this.execAbrilScripts( null, "AbrilBundle.startLinking" );

      if( this.getCookie( 'AbrilLinkingSwg') ){
        console.log("Assinante SWG ou já linkado");
        this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
      }  

    }else{
      this.execAbrilScripts( "AbrilBundle.startLinking", "AbrilBundle.startLinking" );
    }
    if( typeof wp_paywall_vars.subscription_linking == "undefined" ){
      //this.checkLinking();
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startLinking");
      this.execAbrilScripts( "AbrilBundle.startLinking", "AbrilBundle.startLinking" );
    }
    if( typeof googleMarkup == "undefined"){
      this.execAbrilScripts( "AbrilBundle.startLinking", "AbrilBundle.startLinking" );
    }
    
    if( wp_paywall_vars.is_single != 1){
      this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );
    }

    //this.startOntapGoogle();
  }

  async setCustomToken(param) {
    console.log("Auth: set custom token ");
    let data = {}
    if(typeof param == 'number'){
      data = {
        crm: param
      }
    }else if(param.indexOf('@') != -1){
        data = {
          email: param
        }
    }else{
      return;
    }
   
    const response = await $.post({
      url: this.authEndpoint + "/setCustomToken",
      data: data,
      crossDomain: true,
      dataType: "json",
      complete: (xhr, statusText) => {
        return xhr.token;
      }
    }
    ).promise();

    return response?.token;
  }

  showPaywall( eventLabel = this.eventLabel ){
    return AbrilPaywall.showOfferWp( eventLabel );
  }

  hiddePaywall(){
    if( !this.permission && (this.tipo_paywall == "closed" || this.tipo_paywall == "accounted") ) {
      return;
    }

    AbrilPaywall.displayModalPayawall = true;
    if( $("#ip_abril").is(":visible") ){
      if( this.permission  ) {
        return window.location.reload();
      }
    }
    return;
  }

  setlabelEvent(){

    let eventLabel = this.getParam("eventLabel");
    if( eventLabel ){
      return eventLabel;
    }

    if( typeof this.tipo_paywall !== "undefined" ){
      if(  this.tipo_paywall === "closed" ){
        return this.eventLabel = "Bloqueio fechado";
      }
      if( this.tipo_paywall == "accounted" ){
        return this.eventLabel = "Bloqueio contabilizado";
      }
    }

    return 'Acesso Direto';
  }

  browserVersion = (userAgent,regex) => {
    return userAgent.match(regex) ? userAgent.match(regex)[2] : null;
}

  detectBrowser(){

    const userAgent = navigator.userAgent;
    let browser = "unkown";
    // Detect browser name
    browser = (/ucbrowser/i).test(userAgent) ? 'UCBrowser' : browser;
    browser = (/edg/i).test(userAgent) ? 'Edge' : browser;
    browser = (/googlebot/i).test(userAgent) ? 'GoogleBot' : browser;
    browser = (/chromium/i).test(userAgent) ? 'Chromium' : browser;
    browser = (/firefox|fxios/i).test(userAgent) && !(/seamonkey/i).test(userAgent) ? 'Firefox' : browser;
    browser = (/; msie|trident/i).test(userAgent) && !(/ucbrowser/i).test(userAgent) ? 'IE' : browser;
    browser = (/chrome|crios/i).test(userAgent) && !(/opr|opera|chromium|edg|ucbrowser|googlebot/i).test(userAgent) ? 'Chrome' : browser;;
    browser = (/safari/i).test(userAgent) && !(/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i).test(userAgent) ? 'Safari' : browser;
    browser = (/opr|opera/i).test(userAgent) ? 'Opera' : browser;

    // detect browser version
    switch (browser) {
        case 'UCBrowser': return `${browser}/${this.browserVersion(userAgent,/(ucbrowser)\/([\d\.]+)/i)}`;
        case 'Edge': return `${browser}/${this.browserVersion(userAgent,/(edge|edga|edgios|edg)\/([\d\.]+)/i)}`;
        case 'GoogleBot': return `${browser}/${this.browserVersion(userAgent,/(googlebot)\/([\d\.]+)/i)}`;
        case 'Chromium': return `${browser}/${this.browserVersion(userAgent,/(chromium)\/([\d\.]+)/i)}`;
        case 'Firefox': return `${browser}/${this.browserVersion(userAgent,/(firefox|fxios)\/([\d\.]+)/i)}`;
        case 'Chrome': return `${browser}/${this.browserVersion(userAgent,/(chrome|crios)\/([\d\.]+)/i)}`;
        case 'Safari': return `${browser}/${this.browserVersion(userAgent,/(safari)\/([\d\.]+)/i)}`;
        case 'Opera': return `${browser}/${this.browserVersion(userAgent,/(opera|opr)\/([\d\.]+)/i)}`;
        case 'IE': const version = this.browserVersion(userAgent,/(trident)\/([\d\.]+)/i);
            // IE version is mapped using trident version
            // IE/8.0 = Trident/4.0, IE/9.0 = Trident/5.0
            return version ? `${browser}/${parseFloat(version) + 4.0}` : `${browser}/7.0`;
        default: return `unknown/0.0.0.0`;
    }

  }

  async associateTrack( userId ){

    if( !userId || userId == "" || typeof userId == "undefined" ){
      return;
    }

    AbrilCustomDimension.crm_id = this.crm;

    console.log("tenta salvar astro " + this.getUnicId("_ga"))
    await setDoc(doc(this.db, "users",userId),
    { "gaIds" : arrayUnion(this.getUnicId("_ga")) },
    {merge: true}
    );

    if( this.getParam("reader_id") ){
      await setDoc(doc(this.db, "users", userId),
      { readerIds : arrayUnion(this.getParam("reader_id"))},
      {merge: true}
      );
    }

    if( this.getParam("ampReaderId") ){
      await setDoc(doc(this.db, "users", userId),
      { readerIds : arrayUnion(this.getParam("ampReaderId"))},
      {merge: true}
      );
    }

    await this.addPushNewsId( userId );

    return;

  }

  async addPushNewsId( userId ){
    let LocalPushNewsId = localStorage.getItem('pnews_pnid');
    if(LocalPushNewsId != null || LocalPushNewsId != undefined){
        await setDoc(doc(this.db, "users",userId),
        { "pushNewsIdMarca" : arrayUnion(LocalPushNewsId.replace('"', '')) },
        {merge: true}
      );
    }
    return;
  }

  async navegationData( userId , loginType ){

    if( !userId || userId == "" || typeof userId == "undefined" ){
      return;
    }

    await  this.associateTrack( userId );
    let data = Timestamp.fromDate(new Date());
    let device = navigator.userAgent;
    let browserName = this.detectBrowser();
    let dataUserNav = { "date" : data , "userAgent" : device , "browser" : browserName, "brand" : wp_paywall_vars.paywall_brand, "loginType" : loginType};
    let collRef = await collection( this.db , "users/"+userId+"/log_auth");
    try {
    await addDoc( collRef , dataUserNav );
    } catch (err) {
      console.error(err);
    }
    return;

  }

  async getSameUserByGa( gaId , callback, permission, accountedDaysClear, tipo_paywall){

    if( !gaId ){
      return;
    }

    try {
      const querySnapShot = await getDocs(
        query(
          collection( this.db , "users" )
          ,where( "gaIds","array-contains",gaId)
        )
      )

      querySnapShot.forEach( async dados => {
        await callback( dados.id.toString(), this.db, permission, 15, tipo_paywall);
        }
      )

    } catch (err) {
      console.error(err);
    }

  }

  async showModals( data ){

    //console.log(data.data.p.showPayWall);
    //if( parseInt(this.dados_de_contabilizacao) > 2 ){
      //console.log("showModals Redis");
      //console.log(data.data.p.showPayWall);

      if ( data.loggedOut !== "undefined" ) {
        if ( data.loggedOut == "desolgar" ) {
          logoutPaywall(false);
        }
      }

      if (data.data.p.showPayWall === true) {
        console.log("Bloqueio contabilizado - checar Login");
         let eventLabelBloqueio = "Bloqueio contabilizado"
        if (AbrilLogin.getCookie(this.sessionCookieName) !== '') {
          eventLabelBloqueio = "Bloqueio autenticado";
        }

        if(data.reOrderButton === false){
          if(document.getElementById("boxRewardedAds") !== null){
            document.getElementById("boxRewardedAds").style.display = "none";
          }
        }else{
          wp_paywall_vars.rewarded_init = true;
        }

        if( this.tipo_paywall == "temporarily_open" ){
          return ;
        }

        return AbrilPaywall.showOfferWp( eventLabelBloqueio );
      }

      if( parseInt(data.visitadas) > 0 ){
        let accountedMeterData = { 'restantes': data.data.p.materiasrestantes, 'visitada': data.foivisitada };
        return AbrilLogin.receiveAccounted(accountedMeterData);
      }

    //}
    return;
  }

  async getEndpoit( url ){
    if(this.forca_paywall_local){
      return;
    }
    console.log("Tenta acessar Redis REDIS 1");
    try {
      const response = await fetch(url,{
        signal: AbortSignal.timeout(3000),
      });
      if (!response.ok) {
        console.log("Erro ao acessar o Redis 1");
        console.log(response.status);
      }
  
      const json = await response.json();
      console.log(json);
      return this.showModalsTemp( json );
    } catch (error) {
      console.log("Erro ao acessar o Redis 1");
      console.error(error.message);
    }
      return;
  }

  async sendEvetTemp( data ){

    if (data.data.p.showPayWall === true && this.tipo_paywall == "temporarily_open" ) {
      this.sendMetricsGA( 'metric1', 'Paywall', 'Bloqueio de Leitura', 'Bloqueio virtual temporário' );
      return console.log("ENVIA GA ABERTO TEMPORARIO");
    }
    return console.log("NAO ENVIA GA ABERTO TEMPORARIO");
  }

  async showModalsTemp( data ){
 
    //console.log(data.data.p.showPayWall);
    //if( parseInt(this.dados_de_contabilizacao) > 2 ){
      //console.log("showModals Redis");
      //console.log(data.data.p.showPayWall);

      if ( data.loggedOut !== "undefined" ) {
        if ( data.loggedOut == "desolgar" ) {
          logoutPaywall(false);
        }
      }

      if (data.data.p.showPayWall === true ) {

        if( !this.permission ){
          console.log("Força bloqueio sem direito");
          AbrilPaywall.displayModalPayawall = false;
        }

        //console.log("Bloqueio virtual temporário - checar Login");
        this.bloqueioVirtual = true;
         let eventLabelBloqueio = "Bloqueio virtual atingido";
        if (AbrilLogin.getCookie(this.sessionCookieName) !== '') {
          eventLabelBloqueio = "Bloqueio virtual autenticado";
        }

        if(data.reOrderButton === false){
          if(document.getElementById("boxRewardedAds") !== null){
            document.getElementById("boxRewardedAds").style.display = "none";
          }
        }else{
          wp_paywall_vars.rewarded_init = true;
        }

        if( this.tipo_paywall == "temporarily_open" ){
          console.log("AGORA DEVE BLOQUEAR");
          //return ;
        }

        return AbrilPaywall.showOfferWp( eventLabelBloqueio );
      }else{
        if( (parseInt(this.total_views_accounted_virtual) - parseInt(data.data.p.materiasrestantes)) > parseInt(this.total_views_accounted) ){
          if( this.tipo_paywall == "temporarily_open"  ){
          this.sendMetricsGA( 'metric1', 'Paywall', 'Bloqueio de Leitura', 'Bloqueio virtual temporário' );
          //console.log("ENVIA GA ABERTO TEMPORARIO");
          }
        }

      }

      if( parseInt(data.visitadas) > 0 ){
        let accountedMeterData = { 'restantes': data.data.p.materiasrestantes, 'visitada': data.foivisitada };
        return AbrilLogin.receiveAccounted(accountedMeterData);
      }

    //}
    return;
  }  

  async getEndpoitTemp( url ){
    if(this.forca_paywall_local){
      return;
    }
    console.log("Tenta acessar Redis REDIS 2 v1");
      try {
        const response = await fetch(url,{
          signal: AbortSignal.timeout(3000),
        });
        if (!response.ok) {
          console.log("Erro ao acessar o Redis 2");
          console.log(response.status);
        }
    
        const json = await response.json();
        console.log(json);
        return this.showModalsTemp( json );
      } catch (error) {
        console.log("Erro ao acessar o Redis 2");
        console.error(error.message);
      }
      return;

  }

  async accountedData(){
    /*
    console.log( "CONTABILIZAS " + this.tipo_paywall );
    console.log( "CONTABILIZAS " + this.dados_de_contabilizacao );
    console.log( "CONTABILIZAS " + this.total_views_accounted );
    console.log( "CONTABILIZAS " + this.accountedDaysClear);
    */
    let paramas = `?assineEnv=${this.assine_environment}&total_views_accounted=${wp_paywall_vars.total_views_accounted}&total_views_accounted_virtual=${wp_paywall_vars.total_views_accounted_virtual}&metering_expires=${wp_paywall_vars.meteringExpires}&metringMarca=${wp_paywall_vars.paywall_brand}&codIdentificador=${this.getUnicId("_ga")}&codTipoIdentificador=gaId&tipo_paywall=${this.tipo_paywall}&cods=${this.logged_paywall}&reOrder=${wp_paywall_vars.re_order}&qtdeReorder=${wp_paywall_vars.qtde_reorder}&qtdeMateria=${wp_paywall_vars.qtde_materia}&page_url=${window.location.href}`;
    //console.log( "URL REDIS " + this.redisAccountedEndpoint + paramas);
    this.localAccounted( wp_paywall_vars.total_views_accounted, wp_paywall_vars.meteringExpires, wp_paywall_vars.paywall_brand, window.location.href);

    if(this.forca_paywall_local){
      return;
    }

    await this.getEndpoitTemp( this.redisOpenedTempEndpoint + paramas );
    if( this.tipo_paywall == "accounted" ){
      if( !this.bloqueioVirtual ){
        await this.getEndpoit( this.redisAccountedEndpoint + paramas );
      }
    }     
    return;

    //return await AbrilInterfaceMiddleware.checkAccountedViews();

  }

  formatarData(dataString) {
  //dataString = dataString.toString();
  const partes = dataString.split('/');
  const dia = partes[0];
  const mes = partes[1];
  const ano = partes[2];
  return `${mes}/${dia}/${ano}`;
}

  localAccounted( total_views_accounted,meteringExpires, paywall_brand, href ){
   
  let hoje = new Date(new Date().setDate(new Date().getDate())).toLocaleDateString();  
  let renovaAccounted = new Date(new Date().setDate(new Date().getDate() - meteringExpires)).toLocaleDateString();
  let userNavegation = {"marca":paywall_brand,"data":hoje,"urls":[href]};
  let marcaExist = false;
  
  if( localStorage.getItem('AbrilLocalAccounted') == null ){
  userNavegation = JSON.stringify([userNavegation]);
  localStorage.setItem('AbrilLocalAccounted', userNavegation);
  //return;
  }else{
  let dataUserNav = JSON.parse(localStorage.getItem('AbrilLocalAccounted'));

  dataUserNav.forEach(dataUser => {
    //console.log(dataUser.marca); 
    if(dataUser.marca == paywall_brand){
      if( Array.isArray(dataUser.urls)){
        if ( new Date(this.formatarData(dataUser.data)) < new Date(this.formatarData(renovaAccounted)) ) {
          dataUser.urls = [];
          dataUser.data = hoje;
        }

        if(dataUser.urls.length < total_views_accounted){
          if( !dataUser.urls.includes(window.location.href) ){
            dataUser.urls.push(window.location.href);
          }  	
        }
        //console.log(dataUser.urls); 
      }
      marcaExist = true;
    }
  });

  if( !marcaExist ){
  console.log(marcaExist);
  dataUserNav.push(userNavegation);
  userNavegation = JSON.stringify(dataUserNav);
  localStorage.setItem('AbrilLocalAccounted', userNavegation);
  //return;
  }else{
  userNavegation = JSON.stringify(dataUserNav);
  localStorage.setItem('AbrilLocalAccounted', userNavegation);
  //return;	
  }

    let checkShowPaywall = false;
    if(this.forca_paywall_local){
      console.log("@@@@@@ Local Accounted Acionado @@@@@");
      dataUserNav = JSON.parse(userNavegation);
      dataUserNav.forEach(dataUser => {
        console.log(dataUser.marca); 
        if(dataUser.marca == paywall_brand){
          if( Array.isArray(dataUser.urls)){
            if(dataUser.urls.length >= total_views_accounted){
              if( !dataUser.urls.includes(window.location.href) ){
                checkShowPaywall = true;
              }  	
            }
            //console.log(dataUser.urls); 
          }
        }
      });   
 
      let data = {data : {p:{showPayWall: false}}};
      data.data.p.showPayWall = checkShowPaywall;
      return this.showModalsTemp( data );
    }
    return;	
  }

  }

  verifyUserCods(userCods, pageCods = this.logged_paywall ) {

    if(userCods === null || typeof userCods === "undefined" || userCods === ""){
      this.dimensionSign( "", "S/D" );
      return false;
    }

    this.createCookieProductsUser(userCods.join());

    for (let i = 0; i < userCods.length; i++) {
      if (pageCods.indexOf(userCods[i].toString()) != -1) {
        this.dimensionSign( userCods, "Digital" );
        return true;
      }
    }
    this.dimensionSign( userCods, "S/D" );
    return false;
  }

  syncAuth() {
    console.log("Auth: checking user auth status!");
    try {
      this.listenAuthState();
      if ( window.location.href.indexOf("login") > 0 && AbrilLogin.getCookie(this.sessionCookieName) !== '' ) {
        this.signOut(false);
      }
    } catch (err) {
      console.error(err);
    }
  }

  metricUserStatus( status, permission ){

    if( status == "Assinante" && !permission ){
      status = "Registrado"
    }

    if(typeof gtag === 'undefined' ){
			setTimeout((e)=>{
				return this.metricUserStatus( status, permission )	;
			}, 1000);
		} else {
      return gtag('set', { 'dimension28': status });
		}
  }

  dimensionSign( direito, tipo ){

    if( tipo == "S/D" ){
      tipo = "N/A";
      if(direito.length == 0){
        direito = "N/A";
        tipo = "Ex-assinante";
      }else{
        direito = direito.join();
      }

    }

    if( Array.isArray(direito) && direito.length > 0){
      direito = direito.join();
      let combo = logged_paywall_combo[0].split(",");
      for(let i = 0; i < combo.length; i++){
        if (direito.indexOf(combo[i].toString()) != -1 && combo[i] != "") {
          tipo = "Combo";
        }
      }
    }
    this.setOrUpdateUserDataStorage({"tipo_assinatura" : tipo});

    //gtag('set', { 'dimension29' : direito , 'dimension30' : tipo });
    AbrilCustomDimension.sendCustomDimension( { 'dimension29' : direito , 'dimension30' : tipo ,'non_interaction': true } );

  }

  listenAuthState() {

    this.auth.onAuthStateChanged(async (user) => {
      if( user === null ){

        if( this.userState == "logged"){
          return window.location.reload();
        }

        if( this.updateScreen ){
          // AbrilFirebaseInterface.updateScreen();
        }

        this.metricUserStatus( 'Anônimo', false );
        this.dimensionSign( "N/A", "N/A" );
      }

      if (user) {
        //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOntap");
        this.execAbrilScripts( "AbrilBundle.startOntap" );
        if (!user.isAnonymous && user.email && !this.autenticationFlow && user.uid) {
          this.userState = "logged";
          //const idTokenUpdate = await user.getIdToken();
          //this.setCrossSession(idTokenUpdate);
          console.log("Auth: authenticated ", user);
          this.atualuser = user;
            const userSnapshot = await query(this.usersColection, where("uid", "==", user.uid));
            await getDocs(userSnapshot).then( ( querySnapshot ) => {
              querySnapshot.forEach((doc) => {
              this.userData.nomPessoa = doc.data().nomPessoa;
              this.userData.email = doc.data().dscEmail;
              this.userData.listaProjeto = doc.data().listaProjeto;
              this.userData.codClienteLogin = doc.data().codClienteLogin;
              this.userData.crm = doc.data().codClienteCrm;
              this.userData.conteudoFavoritado = doc.data().conteudoFavoritado;
              this.crm = doc.data().codClienteCrm;
              this.codClienteLogin = doc.data().codClienteLogin;
              this.indGoogleSubLinking = doc.data().indGoogleSubLinking;
              this.indGoogleSwg = doc.data().indGoogleSwg;
              this.onboardingVersion = doc.data().onboardingVersion;
              });
            });
          //this.setCrossSession(this.setHashCrm(this.crm));
          
          this.permission = this.verifyUserCods(this.userData.listaProjeto);
          if( this.permission ){
            this.setCrossSession(this.setHashCrm(this.crm));
            await this.userDataStorage();
          }else{
            //console.log("#######  user deslogado automaticamente ###########");
            this.forca_logout = true;
            this.signOut();
          }
          //await this.checkLinking();
          //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
          //this.execAbrilScripts( null, "AbrilBundle.startOnboarding" );
          this.checkOnboarding(this.onboardingVersion,user.uid,this.permission);
          await this.associateTrack(user.uid);
          await this.associateLoginAmp(user.uid);
          this.metricUserStatus( 'Assinante', this.permission );
          AbrilFirebaseInterface.conteudosFavoritados = this.userData.conteudoFavoritado;
          if( this.permission && (this.tipo_paywall == "closed" || this.tipo_paywall == "accounted" )){
            if( typeof AbrilCustomDimension.sendNavigationData != 'undefined' ){
              AbrilCustomDimension.sendNavigationData();
            }
          }
          //this.linkingSwg();
          if ( this.execAbrilScriptsDirect("AbrilBundle.startLinking") ){
            console.log("EXECUTA DIRETO: " + "AbrilBundle.startLinking");
            this.linkingSwgDiredtExec();
          }else{
            this.execAbrilScripts( null, "AbrilBundle.startLinking" );
            this.linkingSwgFila();
          }

          if ( this.execAbrilScriptsDirect("AbrilBundle.startOnboarding") ){
            //console.log("EXECUTA DIRETO: " + "AbrilBundle.startOnboarding")
            //this.checkOnboarding(this.onboardingVersion,user.uid,this.permission);
          }
          this.hiddePaywall();
          if( !this.permission && this.tipo_paywall == "closed" ) {
            this.showPaywall();
          }

          if( !this.permission && this.tipo_paywall == "accounted" ){
            AbrilFirebaseInterface.updateScreen(this.userData);
            return await this.accountedData();
          }

          if( !this.permission && this.tipo_paywall == "temporarily_open" ){
            //AbrilFirebaseInterface.updateScreen(this.userData);
            return await this.accountedData();
          }

          this.autenticationFlow = true;
          if (window.location.href.indexOf("login") < 0) {
            AbrilFirebaseInterface.updateScreen(this.userData);
            return;
          }

          if(document.getElementById("pageLoginVivoFibra") !== null){
            AbrilFirebaseInterface.updateScreen(this.userData);
            return;
          }
          return;
        } else {

          if (this.getCrossSession()) {
            //const idToken = this.getCrossSession();
            //const customToken = await this.getCustomToken(idToken);
            //const userResponse = await signInWithCustomToken(this.auth,customToken);
            /* crm */
            const crmCokie = this.getCrossSession();
            const crmToken = await this.setCustomToken( this.getHashCrm(crmCokie) );
            if (crmToken !== "UNAUTHORIZED REQUEST!!") {
              const userResponse = await signInWithCustomToken(this.auth,crmToken);
            }
            return;
          } else {
            this.clearStorageUser();
            return this.initPaywall();
            if (window.location.href.indexOf("login") < 0) {
              return;
            }

          }
        }
      } else {

        if ( this.getCrossSession() ) {
          //const idToken = this.getCrossSession();
          //const customToken = await this.getCustomToken(idToken);
          //const userResponse = await signInWithCustomToken(this.auth,customToken);
          /* crm */
          const crmCokie = this.getCrossSession();
          const crmToken = await this.setCustomToken( this.getHashCrm(crmCokie) );
          if (crmToken != "UNAUTHORIZED REQUEST!!") {
            const userResponse = await signInWithCustomToken(this.auth,crmToken);
          }
          //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOnboarding");
          //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
          this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );

          //AbrilScriptsExec.removeFunctionList("check_cookie_critica");
          //AbrilScriptsExec.setLoadStatus("check_cookie_critica");
          this.execAbrilScripts( "check_cookie_critica", "check_cookie_critica" );

          return;
        } else {
          //AbrilScriptsExec.removeFunctionList("AbrilBundle.startLinking");
          //AbrilScriptsExec.setLoadStatus("AbrilBundle.startLinking");
          this.execAbrilScripts( "AbrilBundle.startLinking", "AbrilBundle.startLinking" );
          //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOntap");  checa storage ou cockie
          this.checkCookieListControl('AbrilOntap','AbrilBundle.startOntap');
          this.clearStorageUser();
          AbrilFirebaseInterface.updateScreen();
          if( this.tipo_paywall == "closed" ) {
            this.showPaywall();
          }

          if ( typeof activate_onboarding != "undefined" ){
            if( activate_onboarding == "enabled" ){
              if(typeof construct_alert_usersonly === "function"){
                console.log("ONBOARDING SEM PERMISSAO");
                this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );
                construct_alert_usersonly(); 
              }
              //return;
            }
          }
          //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOnboarding");
          //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
          this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );

          //AbrilScriptsExec.removeFunctionList("check_cookie_critica");
          //AbrilScriptsExec.setLoadStatus("check_cookie_critica");
          this.execAbrilScripts( "check_cookie_critica", "check_cookie_critica" );

          if( this.tipo_paywall == "accounted"  || this.tipo_paywall == "temporarily_open" ){
            return await this.accountedData();
            //return await AbrilInterfaceMiddleware.checkAccountedViews();
          }

          return ;
        }
        this.showPaywall();
      }
      
    });


  }



  async initPaywall(){

    if( this.tipo_paywall == "accounted" || this.tipo_paywall == "temporarily_open" ){
      return await this.accountedData();
      //return await AbrilInterfaceMiddleware.checkAccountedViews();
    }

    if( this.tipo_paywall =="closed" ){
      return AbrilPaywall.showOfferWp( this.eventLabel );
    }

  }

  async signInAnonymouslyFirestore() {

    const gaId =  this.getUnicId("_ga");
    const readerId = this.getCookie("amp-access");



    if( typeof gaId == "undefined" || gaId == "" || gaId == null ){
      setTimeout(() => {
        console.log("Tenta pegar rastro novamente");
        return this.signInAnonymouslyFirestore();
      }, "300")
    }


    try {

      const snapshotAnonumousUser = await query(
        this.usersColection,
        where("gaIds", "array-contains", gaId),
        )

      await getDocs(snapshotAnonumousUser).then( async ( querySnapshot ) => {

        if( querySnapshot.size > 0 ){
          let checkDateAccountedExists = undefined;
          let checkreaderIds = undefined;
          let updateAnomimoUser = {};
          let updateAnonimo = false;
          querySnapshot.forEach((doc) => {
            this.currentAnonymousUserId = doc.id;
            checkreaderIds = doc.data().readerIds;
            });

            if( typeof checkreaderIds == "undefined" && readerId ){
              updateAnomimoUser.readerIds = arrayUnion(readerId);
              updateAnonimo = true;
            }

            if( updateAnonimo ){
              await setDoc(doc(this.db, "users", this.currentAnonymousUserId),
              updateAnomimoUser,
              {merge: true}
              );
            }

        }

      });

      return ;




    } catch (error) {
      console.log(error);
    }

    return ;

  }

    signIn(loginAmp, readerId) {
      const $emailField = document.getElementById("signin-email");
      const $passwordField = document.getElementById("signin-password");
      const email = $emailField.value;
      const password = $passwordField.value;
      this.erroLogin = false;

      if (!email || !password) {
        console.log("FALTA DADOS");
        this.erroLogin = true;
        AbrilFirebaseInterface.showError("Preencha todos os campos", true);
        return;
      }

      this.sendMetricsGA( 'metric1', 'Paywall', 'Entrada no fluxo de Login' + this.eventCategoryVivo, this.setlabelEvent() + this.labelAmp );
      AbrilFirebaseInterface.showMessage("Verificando usuário");
      this.verifyUser({ email, password, viewUser: true }).then(async (res) => {
        switch (res.data.status) {
          case true:
          await this.authInFirebase(email, password, res.data);
          break;
          default:
          console.log("Erro ao tentar logar - Assinatura");
          this.erroLogin = true;
          AbrilFirebaseInterface.showError("Usuário não encontrado",true);
          break;
        }

        if (this.loginAmp === "1" && this.erroLogin == false) {
          window.close();
        }
      });

    }

    async signInTerra() {
      if (!this.hasCrossSession()) {
        $('#isLoginCheck').css('display', 'block');
          const crip = this.encriptyData();
          await fetch(this.LoginTerraCheckEndPointWp+'?param='+crip)//enviar dados para daniel
          .then((resp) => {
            return resp.json()
          }).then(async (data) => {
            if (data.codStatus === 'SU' && data.codClienteCrm !== '' && data.codClienteCrm !== undefined) {
              //se retornar SU fazer o login this.LoginTerraCheckEndPointWp
              this.userData.tipo_login = "terra";
              this.setOrUpdateUserDataStorage({"tipo_login" : "Terra"});
              await this.loginParceiros(data.codClienteCrm , 'Terra');
              await this.userDataStorage();
              window.location.href = this.host+'meu-curso';
            } else {//se retonar erro cancelar login
              $('#isLoginCheck').css('display', 'none');
              $('.erro').addClass('show');
              $('.erro').append('Senha ou e-mail inválidos.');
            }
          });
      }
    }

    async signInTerraAutologin() {
      console.log('signInTerraAutologin');
      if (!this.hasCrossSession()) {
          const email =  $("#email2").val();
          if(email.indexOf('@') != -1){
            this.userData.tipo_login = "terra";
            await this.loginParceiros(email, 'Terra');
            await this.userDataStorage();
            window.location.href = this.host+'meu-curso';
          }else{
            $('#isLoginCheck, #form-autologin').css('display', 'none');
            $('#form-send').css('display', 'block');
            $('.erro').addClass('show');
            $('.erro').append('Senha ou e-mail inválidos. <br/> <br/>Lembrete: Se for o primeiro acesso, utilize seu CPF como senha.');
          }
      }
    }

    encriptyData(){
      let element = $("#signin-terra-email").val()+'&7br12o2E'+$("#signin-terra-password").val();
      let i = Math.trunc(Math.random() * (10 - 4) + 4);
         element = btoa(btoa(btoa(btoa(element))));   
     return element+i
    }

  async authInFirebase(email, password, responseFromBackend) {
    AbrilFirebaseInterface.showMessage("Autenticando usuário");

  try{

    await signInWithEmailAndPassword(this.auth, email,password)
    .then( async (userCredential) => {
      if(userCredential.user.email){
        if(this.userData.tipo_login === null){
          this.userData.tipo_login = "abril";
        }
        const user = userCredential.user;
        this.atualuser = this.auth.currentUser;
        await this.navegationData( this.atualuser.uid , "organico" );
        this.setOrUpdateUserDataStorage({"tipo_login" : "Abril"});
        //const idToken = await userCredential.user.getIdToken(true);
        try{
        await this.setCrossSession(this.setHashCrm(this.crm));
        }
        catch(error){
          console.log("setCrossSession");
          console.log(error);
        }
        this.userState = "logged";
        try{
          let eventLabel = this.setlabelEvent();

          if (this.loginAmp === "1" && this.erroLogin == false) {
            eventLabel = "Bloqueio contabilizado ";
          }
          this.sendMetricsGA( 'metric2', 'Paywall', 'Login Efetuado' + this.eventCategoryVivo, eventLabel + this.labelAmp );

          console.log("Volta para a página de origem");

          if( this.loginAmpCdn == 1 ){
            return;
          }

          AbrilFirebaseInterface.reloadPageAfterLogin();
        }catch(error){
          console.log(error);
        }

      }else{
        AbrilFirebaseInterface.showError("Falha na autenticação",true);
        this.erroLogin = true;
        console.log("Falha na autenticação");
      }
    });

  }catch(error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    switch (error.code) {
      case "auth/wrong-password":
      AbrilFirebaseInterface.showError("E-mail ou senha incorretos", true);
      break;
      case "auth/user-not-found":
      AbrilFirebaseInterface.showError("Usuário não encontrado", true);
      break;
      case "auth/invalid-email":
      AbrilFirebaseInterface.showError("Email inválido", true);
      break;
      case "auth/too-many-requests":
      AbrilFirebaseInterface.showError("Usuário bloqueado temporariamente, aguarde alguns minutos e tente novamente.", true);
      break;
      default:
      console.log("login organico");
      console.log(error);
      AbrilFirebaseInterface.showError("Algo de errado tente novamente mais tarde.", true);
      break;
  };

  };

  }



updateDateAccountedLoged( dateAccountedLoged, dateAccountednoymous ){

  if( dateAccountednoymous == "undefined" ){
    dateAccountednoymous = undefined;
  }
  if( dateAccountedLoged == "undefined" ){
    dateAccountedLoged = undefined;
  }

  let dataLimiteAccounted = this.accountedDaysClear;
  var DT_VENC = new Date();
  var DT_AVISO = new Date().setDate(DT_VENC.getDate() - dataLimiteAccounted);
  let DT_AVISO_F = new Date(DT_AVISO).getFullYear() + '-' + (new Date(DT_AVISO).getMonth() + 1) + '-' + new Date(DT_AVISO).getDate();
  let dataCurrent = Timestamp.fromDate(new Date());

    if( typeof dateAccountedLoged === "undefined" && typeof dateAccountednoymous !== "undefined" ){
      dataCurrent = dateAccountednoymous;
    }

    if( typeof dateAccountedLoged !== "undefined" && typeof dateAccountednoymous === "undefined" ){
      dataCurrent = dateAccountedLoged;
    }

    if( typeof dateAccountedLoged !== "undefined" && typeof dateAccountednoymous !== "undefined" ){
      if( dateAccountedLoged.toDate() >= dateAccountednoymous.toDate() ){
        dataCurrent = dateAccountednoymous;
      }else{
        dataCurrent =  dateAccountedLoged;
      }
    }

    if( dataCurrent.toDate() < new Date(DT_AVISO) ){
      dataCurrent = Timestamp.fromDate(new Date());
    }

return dataCurrent;

}

async associateLoginAmp(uid){

  if( this.loginAmpCdn == 1 || this.loginAmp === "1"){

    if( this.getParam("reader_id") && typeof uid !== "undefined"){
      await setDoc(doc(this.db, "users", uid),
      { readerIds : arrayUnion(this.getParam("reader_id"))},
      {merge: true}
      );
        return window.close();
   }

    if( this.getParam("ampReaderId") && typeof uid !== "undefined"){
      await setDoc(doc(this.db, "users", uid),
      { readerIds : arrayUnion(this.getParam("ampReaderId"))},
      {merge: true}
      );
        return window.close();
   }

  }
  return;
}

async associateMasterAccount(anonymousUserId, masterUser) {
  console.log("TENDADO RELACIONAR GA e READER");
  //console.log(masterUser);
  //console.log(anonymousUserId);

  await this.associateLoginAmp(masterUser.uid);


  let gaIdTracking =  this.getUnicId("_ga");
  let readerIdTracking = this.getCookie("amp-access");
  let lgpdAnoymous = [];
  let dateAccountednoymous = "undefined";
  let relacionar = false;
  let updateUserData = {};

  if( this.loginAmpCdn == 1 ){
    readerIdTracking = this.readerIdCdn;
  }

  if( typeof anonymousUserId !== "undefined"){
    if (anonymousUserId.toString() == masterUser.uid) {
      //console.log("Náo associar: " + anonymousUserId);
      return;
    }
  }

  if (typeof gaIdTracking === "undefined" || gaIdTracking === "" || gaIdTracking === null) {
    return console.log(" Não encontrou rastros");
  }
  //console.log("GAID " + gaIdTracking);
  //console.log("READERID " + readerIdTracking);
  //console.log("ANONY " + this.currentAnonymousUser);
  //console.log("MASTER " + masterUser);

  const q = await query(this.usersColection, where("dscEmail", "==", masterUser.email.toUpperCase()));

  await getDocs(q).then( ( querySnapshot ) => {
    querySnapshot.forEach((doc) => {
    //console.log(doc.data().nomPessoa);
    updateUserData.gaIds = doc.data().gaIds;
    updateUserData.readerIds = doc.data().readerIds;
    updateUserData.anonymousUsers = doc.data().anonymousUsers;
    });
  });
  //console.log("MASTER d " + updateUserData.dateAccounted);
  //console.log("MASTER d " + dateAccountednoymous);
  updateUserData.dateAccounted = this.updateDateAccountedLoged( updateUserData.dateAccounted, dateAccountednoymous );

  if (typeof updateUserData.anonymousUsers === 'undefined') updateUserData.anonymousUsers = [];
  if (typeof updateUserData.gaIds === 'undefined') updateUserData.gaIds = [];
  if (typeof updateUserData.readerIds === 'undefined') updateUserData.readerIds = [];
  if (typeof updateUserData.lgpd === 'undefined') updateUserData.lgpd = [];

  //console.log(updateUserData.anonymousUsers);
  //console.log(updateUserData.gaIds);
  //console.log(updateUserData.readerIds);

  if ( updateUserData.anonymousUsers.indexOf(anonymousUserId) === -1 && typeof anonymousUserId !== 'undefined' ) {
    relacionar = true;
    updateUserData.anonymousUsers.push(anonymousUserId);
  }

  if ( updateUserData.gaIds.indexOf(gaIdTracking) === -1 && gaIdTracking ) {
    updateUserData.gaIds.push(gaIdTracking);
    relacionar = true;
  }

  if ( updateUserData.readerIds.indexOf(readerIdTracking) === -1 && readerIdTracking ) {
    updateUserData.readerIds.push(readerIdTracking);
    relacionar = true;
  }

  updateUserData.date = Timestamp.fromDate(new Date());

  if( updateUserData.gaIds.length > this.maxTrail ){
    updateUserData.gaIds.splice(0, ( updateUserData.gaIds.length - this.maxTrail ) );
  }

  if( updateUserData.readerIds.length > this.maxTrail ){
    updateUserData.readerIds.splice(0, ( updateUserData.readerIds.length - this.maxTrail ) );
  }

  if( updateUserData.anonymousUsers.length > this.maxTrail ){
    updateUserData.anonymousUsers.splice(0, ( updateUserData.anonymousUsers.length - this.maxTrail ) );
  }

  if (!relacionar) {
    return console.log("FIM DO RELACIONAR GA e READER SEM RELACIONAR");
  }
  //console.log(masterUser.uid);
  //console.log(updateUserData);
  await setDoc(doc(this.db, "users", masterUser.uid),
  updateUserData,
  {merge: true}
  );

  console.log("Sucesso sync!");

  if( this.loginAmpCdn == 1 ){
    readerIdTracking = this.readerIdCdn;
    return window.location.href = this.getParam("redirect_uri") + "#access_token=" + this.userData.codClienteLogin + "&token_type=bearer" + "&state=" + this.getParam("state");
  }

return;


}

createCookieProductsUser(codes){
  var d = '';
  d = new Date();
  d.setTime( d.getTime() + (1000*60*60*24*30)) ;
  this.setCookie( 'AbrilProductsUser', codes, d );
  if( localStorage.getItem('AbrilProductsUser') == null ){
    localStorage.setItem('AbrilProductsUser', codes);
  }
}

setCookie(cname, value, date) {
  //console.log('atualizando ' + cname);
  var expires = '';
  if(date) {
    var d = date;
    expires = "expires="+ d.toUTCString();
  }
  document.cookie = cname+"="+value+";" + expires + ";domain=.abril.com.br;path=/";
}


setTokenCookie(name, value, days) {
  //console.log("Setou " + name);
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000 * 360);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + ";domain=.abril.com.br;path=/";

}

getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

getUnicId(name){
  if( localStorage.getItem('abrilUserId') ){
    return localStorage.getItem('abrilUserId');
  }

  if( name == "_ga" ){
    if( typeof gaGlobal !== "undefined" ){
      if( typeof gaGlobal.vid !== "undefined" ){
        localStorage.setItem('abrilUserId', gaGlobal.vid);
        return gaGlobal.vid;
      }
    }
  }

  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) {
      if( name == "_ga"){

        if( typeof c.substring(nameEQ.length, c.length) == "undefined" ){
          return null;
        }

        return c.substring(nameEQ.length, c.length).split(".")[2] + "." + c.substring(nameEQ.length, c.length).split(".")[3];
      }
      return c.substring(nameEQ.length, c.length);
    }
  }

  return null;
}

eraseCookie(name) {
  document.cookie =
  name + "=;domain=abril.com.br; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

setCrossSession(idToken) {
  this.setTokenCookie(this.sessionCookieName, idToken, 1);
}

getCrossSession() {
  return this.getCookie(this.sessionCookieName);
}

crossSignOut() {
  this.eraseCookie(this.sessionCookieName);
  return;
}

hasCrossSession() {
  return this.getCookie(this.sessionCookieName) != null;
}

hasCrmCrossSession() {
  return this.getCookie(this.sessionCookieName) != null;
}

setHashCrm(v){
  v = v.toString();
	const t = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm','n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9','!','?','-'];
	let h = "";
	for(let w = 0; w < 50; w++){
		let i = t[Math.floor(Math.random() * (t.length))];
		if( Math.floor(Math.random() * 2)){
			i = i.toUpperCase();
		}
		let ij = t[Math.floor(Math.random() * (t.length))];
		if( Math.floor(Math.random() * 2)){
			ij = ij.toUpperCase();
		}

		if(w == 5){
			let tt = v.length;
			if (v.length < 10){
				tt = "0"+ v.length;
			}
			h = h + tt;
		}

		if(w == 8){

			for(let g=0; g < v.length; g++){
				let j = t[Math.floor(Math.random() * (t.length))];
				if( Math.floor(Math.random() * 2)){
					j = j.toUpperCase();
				}
				h = h + v[g] + j + ij;

			}
		}
		h = h + i ;
	}
	return h;
}

getHashCrm(h){
	let cr = ""
	for(let g=10; g < 10 + Number(h[5]+h[6])*3 ; g = g + 3){
		cr = cr + h[g];
	}
	return Number(cr);
}

async getCustomToken(idToken) {
  console.log("Auth: getting custom token");
  const response = await $.post({
    url: this.authEndpoint + "/getCustomToken",
    data: {
      idToken: idToken,
    },
    crossDomain: true,
    dataType: "json",
    complete: (xhr, statusText) => {
      if (xhr.status == 401){
        console.log(xhr.status);
        this.eraseCookie(this.sessionCookieName);
        return this.listenAuthState();
      }
      }
  }
  ).promise();

  return response?.token;
}

async signOut(reloadpage = true){
  console.log("Saindo");
  if(document.getElementById("isLoginCheckMsgText") !== null){
    AbrilFirebaseInterface.showMessage("Aguarde...");
    console.log("auto logoff")
  }
  this.clearStorageUser();
  await signOut(this.auth).then(function() {
    console.log('Signed Out Lib');
  });

  this.updateScreen = false;
  this.eraseCookie("AbrilProductsUser");
  this.eraseCookie("amp-access");
  this.crossSignOut();
 
  if(document.getElementById("isLoginCheckMsgText") !== null){
    AbrilFirebaseInterface.removeMessage();
  }
  const dimensionsGA4 = {
    "tipo_cadastro": "nao logado",
    "tipo_assinatura": "nao logado"
  }
  this.sendMetricsGA( 'metric2', 'Paywall', 'Logout Efetuado', "", dimensionsGA4);
  console.log("Saindo fim");

  if( this.forca_logout == true ){
    if( this.getParam("url-retorno") != null && this.getParam("url-retorno") != "" ){
      //return window.location.href = "https://assine.abril.com.br/?msglogout=assine";
      return window.location.href = this.getParam("url-retorno");
    }
  }
  
  if (reloadpage === false) {
    return;
  }

  window.location.reload();
}

getCokieLogout(){
  return this.getCookie( 'AbrilLogout');
}

async setCokieLogout(){
  console.log("CRIA COKIE LOGOUT !!!!!!!!!!!!!!!!!");
  var d = '';
  d = new Date();
  d.setTime( d.getTime() + (1000*60*60*24*30)) ;
  return this.setCookie( 'AbrilLogout', true, d );
}

getParam(paramName){
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  return urlParams.get(paramName);
}

async addReadeIdUser( userDataAmp, readerIdTracking,readerIds ){
  let relacionarAMP = false;

  if(userDataAmp === null) {
    return console.log("Sem user GA ");
  }

  if(readerIdTracking === null) {
    return console.log("Sem user ReaderId ");
  }

  if( typeof readerIds === "undefined" ) {
    readerIds = [];
  }

  if ( readerIds.indexOf(readerIdTracking) === -1) {
    relacionarAMP = true;

    await setDoc(doc(this.db, "users", userDataAmp),
    { "readerIds" : arrayUnion(readerIdTracking) },
    {merge: true}
    );
  }


  return;

}

async syncAmp(){
  let gaIdTracking =  this.getUnicId("_ga");
  let readerIdTracking = this.getCookie("amp-access");
  let readerIds = [];

  if( gaIdTracking.indexOf("GA") > 0){
    gaIdTracking = gaIdTracking.substring(gaIdTracking, gaIdTracking.length).split(".")[2] + "." + gaIdTracking.substring(gaIdTracking, gaIdTracking.length).split(".")[3];
  }

  console.log("iframe AMP");
  console.log(gaIdTracking,readerIdTracking);

  if( !gaIdTracking || !readerIdTracking){
    console.log("Sem relacionamentos");
    return;
  }

  let userDataAmp = null;
  const userSnapshot = query(this.usersColection, where("gaIds", "array-contains", gaIdTracking));
  await getDocs(userSnapshot).then( ( querySnapshot ) => {
    console.log(querySnapshot.length);
    querySnapshot.forEach( async (doc) => {
    console.log(doc.id);
    userDataAmp = doc.id;
    readerIds = doc.data().readerIds;
    await this.addReadeIdUser( userDataAmp,readerIdTracking,readerIds );
    });
  });

  if(userDataAmp === null) {
    return console.log("Sem user GA ");
  }

  if(readerIdTracking === null) {
    return console.log("Sem user ReaderId ");
  }


  /* Logado */

  let userDataAmpLogado = null;

  if (this.getCrossSession()) {
    //const idToken = this.getCrossSession();
    //const customToken = await this.getCustomToken(idToken);
    //const userResponse = await signInWithCustomToken(this.auth,customToken);
    const crmCokie = this.getCrossSession();
    const crmToken = await this.setCustomToken( this.getHashCrm(crmCokie) );
    const userResponse = await signInWithCustomToken(this.auth,crmToken);
    userDataAmpLogado = userResponse.user.uid;
  }else{
    return;
  }

  let updateUserData = {};
  let relacionar = false;
  const userSnapshotLoged = await query(this.usersColection, where("uid", "==", userDataAmpLogado));
  await getDocs(userSnapshotLoged).then( ( querySnapshot ) => {
    querySnapshot.forEach((doc) => {
    //console.log(doc.data().uid);
    updateUserData.readerIds = doc.data().readerIds;
    });
  });

  if (typeof updateUserData.readerIds === 'undefined') updateUserData.readerIds = [];

  if ( updateUserData.readerIds.indexOf(readerIdTracking) === -1 && readerIdTracking ) {
    updateUserData.readerIds.push(readerIdTracking);
    relacionar = true;
  }

  if (!relacionar) {
    return console.log("FIM DO RELACIONAR GA e READER SEM RELACIONAR LOGADO");
  }

  await setDoc(doc(this.db, "users", userDataAmpLogado),
  { "readerIds" : updateUserData.readerIds },
  {merge: true}
  );

  //console.log("Sucesso GA AMP LOGGEED !");


}

async loginGoogle() {
  this.userData.tipo_login = "google-form";
  this.setOrUpdateUserDataStorage({"tipo_login" : "Google"});
  this.sendMetricsGA( 'metric1', 'Paywall', 'Entrada no fluxo de Login - Google', this.setlabelEvent() + this.labelAmp );
  var provider = new GoogleAuthProvider();
  signInWithPopup(this.auth, provider)
  .then((result) => {
    const details = getAdditionalUserInfo(result);
    const credential = GoogleAuthProvider.credentialFromResult(result);

    var token = credential.accessToken;
    var user = result.user;
    var email = user.email;

    //console.log("token", token);

    if (details.isNewUser) {
      user
      .delete()
      .then(() => {
        console.log("logou, deletou novo user de forma automatica");
      })
      .catch((error) => {
        AbrilFirebaseInterface.showError("Usuário não existe na base de dados!",true);
        console.log("loginGoogle: Error deleting user:", error);
      });
    }
    console.log(email);
    AbrilFirebaseInterface.showMessage("Verificando usuário");
    const response = this.verifyUser({ email }).then((response) => {

      console.log('====== verifyUser =======');
      console.log(response);
      const data = response.data;
      console.log(data.status);
      if (data.status) {
        console.log("loginGoogle2: Usuário criado");
        const user = data.user;

        this.authInFirebaseSSO(credential, user);
        console.log("loginGoogle2: authInFirebaseSSO");
      } else {
        AbrilFirebaseInterface.showError("Usuário não encontrado",true);
        console.log("signOutSSO usuário não encontrado!")
        this.signOutSSO(false);
      }
      console.log('====== fim login google =======');
    });
  })
  .catch((error) => {

      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(error.message);
      var email = error.email;
      var credential = error.credential;
      AbrilFirebaseInterface.showError("Usuário não existe na base de dados!",true);
    });
}

async authInFirebaseSSO(credential, user) {
  try {
    this.userData.tipo_login = "google-form";
    this.setOrUpdateUserDataStorage({"tipo_login" : "Google"});
    AbrilFirebaseInterface.showMessage("Autenticando usuário");
    const userGoogle = await signInWithCredential(this.auth, credential);
    const idToken = await userGoogle.user.getIdToken(true);
    this.setCrossSession(idToken);

    await this.navegationData( userGoogle.user.uid , "google" );
    
    this.sendMetricsGA( 'metric2', 'Paywall', 'Login Efetuado - Google', this.setlabelEvent() + this.labelAmp );

    console.log("CONSEGUIU LOGAR");
    this.userState = "logged";
    if(this.swgUser){
      return window.location.reload();
    }

    if (this.loginAmp === "1") {
      return window.close();
    }

    AbrilFirebaseInterface.reloadPageAfterLogin();

  } catch (error) {
    console.log("NÃO CONSEGUIU LOGAR");
    console.log({ error });
    switch (error.code) {
      case "auth/wrong-password":
      AbrilFirebaseInterface.showError("E-mail ou senha incorretos", true);
      break;
      case "auth/user-not-found":
      AbrilFirebaseInterface.showError("Usuário não encontrado", true);
      break;
      case "auth/invalid-email":
      AbrilFirebaseInterface.showError("Email inválido", true);
      break;
      case "auth/too-many-requests":
      AbrilFirebaseInterface.showError("Usuário bloqueado temporariamente, aguarde alguns minutos e tente novamente.", true);
      break;
      default:
        console.log("login google");
        console.log(error);  
      AbrilFirebaseInterface.showError("Algo de errado tente novamente mais tarde.", true);
      break;
    }
  }
}

  signOutSSO() {
    console.log("User signed out signOutSSO.");
    this.signOut();
  }

  sendMetricsGA( metric, eventCategory, eventAction, eventLabel, dimensionsGA4 = ""){
		if ( typeOfMethodCompare(wp_paywall_vars) === "undefined" ) {
			setTimeout((e)=>{
				this.sendMetricsGA( metric, eventCategory, eventAction, eventLabel )	;
			}, 1000);
		} else {

			if ( this.isGaCreated === false ) {
        methodTagConfig(wp_paywall_vars.id_analytics_brand, '_ga'+paywall_brand[0], 'abril.com.br');
				this.isGaCreated = true;
			}

      let eventGa = {
        "metric": metric,
        "category": eventCategory,
        "action": eventAction,
        "label": eventLabel,
      };

      if( dimensionsGA4 !== ""){
        eventGa["dimensionsGA4"] = dimensionsGA4;
      }
      gaSendEvent(eventGa);
		}
	}

startSwG() {
  console.log(" ############. SWG . ###############");
    (self.SWG = self.SWG || []).push(subscriptions => {
      console.log(" ############. STARTOU SWG 1 . ###############");
      console.log(customData.productID);
      console.log(subscriptions);
      if( this.rrme ){
        subscriptions.configure({paySwgVersion: '2'});
        // subscriptions.init(customData.productID);
      }
      console.log(" ############. STARTOU SWG 2 . ###############");
      console.log(subscriptions);
        window.subscriptions = subscriptions;

        subscriptions.getEntitlements().then( entitlements => {
          if (entitlements.entitlements == '') {
            if ( AbrilLogin.getCookie(this.sessionCookieName) !== '' ) {
              console.log(" ############. SWG 2 - VINCULO . ###############");
            }
          }
        });
        
        subscriptions.setOnEntitlementsResponse( entitlementsPromise => {
          entitlementsPromise.then( async entitlements => {
            console.log(" ############. SWG 3 - AUTO LOGIN . ###############");
            console.log(entitlements);
            
            let showPaywallSWG = true;
            if ( AbrilLogin.getCookie(this.sessionCookieName) === '' ) {
              if (typeof entitlements.entitlements != 'undefined' || entitlements.entitlements !== null) {
                let swgbuyOrderID = "";
                if(Array.isArray(entitlements.entitlements)){
                  if( entitlements.entitlements.length <= 0){
                    if(wp_paywall_vars.tipo_paywall == "closed" && AbrilPaywall.ShowPaywall !== true){
                      
                      return AbrilPaywall.showOfferWp("Bloqueio fechado");
                    }
                    return;
                  }
                  
                  for(var ent = 0; ent < entitlements.entitlements.length; ent ++ ){
                    let swgbuy = JSON.parse( entitlements.entitlements[ent].subscriptionToken );
                    if( swgbuy.orderId ){
                      console.log("AUTOLOGIN SWG  " + entitlements.entitlements[ent].subscriptionToken );
                      showPaywallSWG = false;
                      console.log("AUTOLOGIN SWG VINCULADO " + entitlements );
                      
                      if (swgbuy.orderId) {
                        console.log(swgbuy.orderId);
                        swgbuyOrderID = swgbuy.orderId;
                        if (swgbuyOrderID !== undefined && swgbuyOrderID !== null && swgbuyOrderID !== "") {
                          console.log("buscarSwgUser");
                          const buscarSwgUser = await this.getSwgUser2(swgbuyOrderID);
                          console.log(buscarSwgUser);
                          if (buscarSwgUser.codStatus === "SU") {
                            await this.loginParceiros(buscarSwgUser.dscEmail, 'SwG');
                            this.sendMetricsGA( 'metric1', 'Paywall', 'Login Efetuado', 'SwG - Login automático', '');
                            console.log(" ############. SWG 4 - AUTO LOGIN . ###############");
                            subscriptions.waitForSubscriptionLookup(buscarSwgUser).then(account => {
                              console.log(account);
                              if (account) {
                                console.log(" ############. SWG 6 - FAZENDO LOGIN . ###############");
                                subscriptions.showLoginNotification().then(() => {});
                              }
                            });
                          }
                        }
                      }
                    }
                  }
                }
              }
              entitlements.ack();
            }else{
              entitlements.ack();
            }
          });
        });        
      
		});
		AbrilLogin.hideButtons();
}

async sendCrmSwg( crm ){
  let url = "/linking-swg/?cod_swg=" + crm;
  $.ajax({
    url: url,
    type: 'get',
    dataType: 'json',
    async: false,
    success: data => {
      return data ;
    },
  });

}

escapeBySlug( urlCheck, blackList ){
  let secapeSlug = false;
  blackList.forEach(slug => {
    if( urlCheck.indexOf("/"+slug+"/") >= 0 || urlCheck.indexOf("/"+slug) >= 0 ){
      secapeSlug = true;
      return secapeSlug;
    }
  })
  return secapeSlug;
}

async linkingSwg(){
  console.log("LINKING");

  //this.execAbrilScripts( null,"AbrilBundle.startLinking" );

  /** forca cokie para ordenacao de exec de script */
  var d = '';
  d = new Date();
  d.setTime( d.getTime() + (1000*60*60*24*30)) ;
  this.setCookie( 'AbrilLinkingSwg', this.userData.listaProjeto, d );
  //this.execAbrilScripts( null,null,null,null,null,"AbrilBundle.startLinking" );

  if( typeof customData == "object" ){
    if( this.crm != null ){
      console.log("Tenta abrir modal Linking");
      self.SWG.push(async (subscriptions) => {
        console.log(subscriptions);
        try {
          console.log("Tenta lincar assinatura");
          const result = await subscriptions.linkSubscription({
            publisherProvidedId: this.crm,
          })
          console.log("Tenta lincar assinatura result");
          //var d = '';
          //d = new Date();
          //d.setTime( d.getTime() + (1000*60*60*24*30)) ;
          //this.setCookie( 'AbrilLinkingSwg', this.userData.listaProjeto, d );
          console.log(result);
          if( result.success )
          {
            this.sendCrmSwg( this.crm );   
            this.sendMetricsGA( 'metric1', 'Paywall', 'Vínculo de conta efetuado' , '' );
            console.log("Efetuado vínculo assinatura");
          }else{
            this.sendMetricsGA( 'metric1', 'Paywall', 'Vínculo de conta rejeitado' , '' );
            console.log("Cancela vínculo assinatura");
          }

        } catch(e) {
          console.log("Falhou abrir modal Linking");
          console.log(e);
        }
      })

    }
  }


}

async linkingSwgFila(){

  console.log("CHECA LINKING NA FILA !!!!!!!");

  let showInPage = false;
  if( wp_paywall_vars.is_single == 1){
    showInPage = true;
  }
  if( !wp_paywall_vars.subscription_linking || showInPage == false){
    //AbrilScriptsExec.removeFunctionList("AbrilBundle.startLinking");
    this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
    return;
  }   

  let blackList = ["login","ofertas","assinar","meu-curso"];
  if( this.escapeBySlug( window.location.href, blackList ) ){
    //console.log("LINKING SWG DESLIGADO NESTE SLUG");
    this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
    return;
  }

  if( !wp_paywall_vars.subscription_linking ){
    //console.log("LINKING SWG DESLIGADO");
    return;
  }

  if( this.getCookie( 'AbrilLinkingSwg') || this.indGoogleSubLinking == "S" || this.indGoogleSwg == "S" ){
    console.log("Assinante SWG ou já linkado");
    this.createCookieListControl('AbrilLinkingSwg');
    this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
    return;
  }  

  if( this.userData.listaProjeto instanceof Array ){
    if( this.userData.listaProjeto.length > 0 ){
    }else{
      console.log("USER SEM LISTA DE PROJETOS");
      this.createCookieListControl('AbrilLinkingSwg');
      this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
      return;
    }
  }else{
    if( this.userData.listaProjeto == null){
      console.log("LISTA DE PROJETOS NULL");
      this.createCookieListControl('AbrilLinkingSwg');
      this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
    }
    return;
  }

  if( !AbrilScriptsExec.checkExecFunctionList("AbrilBundle.startLinking") ){
    //AbrilScriptsExec.removeFunctionList("AbrilBundle.startLinking");
    console.log("LINKING AGUARDANDO ORDEM NA FILA!!");
    AbrilScriptsExec.setLoadStatus("AbrilBundle.startLinking");
    //this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking" );
    return;
  }     

}

async linkingSwgDiredtExec(){

  let showInPage = false;
  if( wp_paywall_vars.is_single == 1){
    showInPage = true;
  }
  if( !wp_paywall_vars.subscription_linking || showInPage == false){
    return;
  }   

  let blackList = ["login","ofertas","assinar","meu-curso"];
  if( this.escapeBySlug( window.location.href, blackList ) ){
    return;
  }

  if( !wp_paywall_vars.subscription_linking ){
    return;
  }

  if( this.getCookie( 'AbrilLinkingSwg') || this.indGoogleSubLinking == "S" || this.indGoogleSwg == "S" ){
    console.log("Assinante SWG ou já linkado");
    return;
  }  

  if( this.userData.listaProjeto instanceof Array ){
    if( this.userData.listaProjeto.length > 0 ){
    }else{
      console.log("USER SEM LISTA DE PROJETOS");
      this.createCookieListControl('AbrilLinkingSwg');
      return;
    }
  }else{
    if( this.userData.listaProjeto == null){
      console.log("LISTA DE PROJETOS NULL");
      this.createCookieListControl('AbrilLinkingSwg');
    }
    return;
  }

  return this.linkingSwg();
  
}

swgBuyFlow( eDataValue, assineUrl, eventLabel){
  console.log("xxx swgBuyFlow xxx");
  this.sendMetricsGA( "metric1", "Paywall", "Entrada no Fluxo de Pagamento", "SwG - " + eventLabel);
  let metadado = "cl_paywall";
  const originString = window.location.href;
  if( (originString.indexOf("/ofertas/") >= 0 || originString.indexOf("/ofertas") >= 0) ){
    metadado = "cl_ofertas";
  }
  AbrilStorageMetadado.add("source", metadado);  
  subscriptions.subscribe(eDataValue);
  subscriptions.setOnPaymentResponse(paymentResponse => {
    paymentResponse.then((response) => {
      this.sendMetricsGA( 'metric1', 'Fluxo de assinatura', 'F-Compra' , 'FinalizarCompraSwG' );
      //let emailUser = response.userData.email;
      let purchaseInfo = JSON.parse( response.purchaseData.data );
      console.log(response);
      response.complete().then( async response2 =>{
        console.log("xxx Liberar conteúdo xxx");
        console.log(response2);
        this.sendMetricsGA( 'metric1', 'Paywall', 'Pagamento Efetuado' , 'SwG - ' + eventLabel );
        gaPurchase(purchaseInfo.orderId, $("#purchase").data("swg_price"), purchaseInfo.orderId, $(".btn-offer-google").data("swgSku"), wp_paywall_vars['paywall_brand'], 'Anual/Swg', $("#purchase").data("swg_id"), 'Google Swg');
        AbrilStorageMetadado.add("event", "pedido");
        this.userData.tipo_login = "google-swg";
        this.setOrUpdateUserDataStorage({"tipo_login" : "Google Swg"});

        const buscarSwgUser = await this.getSwgUser2(purchaseInfo.orderId);
        if( buscarSwgUser.codStatus === "SU" ){
          await this.loginParceiros(buscarSwgUser.dscEmail, "SwG");
        }

        // await this.loginParceiros(emailUser, "SwG");
        // await this.userDataStorage();
        //AbrilScriptsExec.eraseCookieList("AbrilOntap");
        this.execAbrilScripts( null, null, null, "AbrilOntap" );
        if( (originString.indexOf("/ofertas/") >= 0 || originString.indexOf("/ofertas") >= 0) ){
          console.log("redirect");
          window.location.href = window.location.origin;
          return;
        }
        console.log("reload");
        //window.location.reload();
      });
    });
  });
}

getSwgUser(d, callback) {
  let packageName;
  let productId;
  let purchaseToken;
  let get_swg_user_ajax_nonce = $("#get_swg_user_ajax_nonce").val();

  if( d.entitlements && d.entitlements.length ) {
    for ( let i = 0; i < d.entitlements.length; i++ ) {
      let subscriptionToken;
      try{
        subscriptionToken = JSON.parse( d.entitlements[i].subscriptionToken );
        if(subscriptionToken.purchaseToken) {
          packageName   = subscriptionToken.packageName;
          productId     = subscriptionToken.productId;
          purchaseToken = subscriptionToken.purchaseToken;
        }
      } catch {}
    }

    let request = $.ajax({
      url: ajaxurl,
      method: "POST",
      async: false,
      complete: function(data) {
        if (callback) {
          callback(data);
        }
      },
      data: {
        action: "get_swg_user",
        get_swg_user_ajax_nonce: get_swg_user_ajax_nonce,
        packageName: packageName,
        productId: productId,
        purchaseToken: purchaseToken
      }
    });
  }
}

async getSwgUser2(swgbuyOrderID) {
  console.log("getSwgUser2");
  let get_swg_user_ajax_nonce = $("#get_swg_user_ajax_nonce").val();
  let result = $.ajax({
    url: ajaxurl,
    method: "POST",
    data: {
      action: "get_swg_user2",
      get_swg_user_ajax_nonce: get_swg_user_ajax_nonce,
      orderID: swgbuyOrderID
    },
    async: true,
    complete: function(data) {
      if (typeof callback !== "undefined") {
        callback(data.responseText);
      }
    }
  });
  return result;
};

async loginParceiros(param, loginType = "") {
  if (param === null) { return; }
  let customToken = await this.setCustomToken(param);
  if (customToken === "UNAUTHORIZED REQUEST!!") {
    return;
  }
  const userResponse = await signInWithCustomToken(this.auth, customToken);
  if (loginType !== "") {
    this.navegationData(userResponse.user.uid, loginType);
  }
}

async favoritar(postId,postType,marca,dataFavoritadoEm){
  console.log("FAVORITAR");
  let classId = false;
  if( postType == "author" || postType == "blog"){
    classId = postId;
  }
  AbrilFirebaseInterface.mostraBotFavoritar(false,postType,classId);
  const date = new Date();
  const today = date.getDate().toString().length == 2 ? date.getDate() : `0${date.getDate()}`;
  let currentMonthSum = (date.getMonth() + 1).toString(); 
  let currentMonth = currentMonthSum.length == 2 ? currentMonthSum : `0${currentMonthSum}`;
  const currentYear = date.getFullYear();
  dataFavoritadoEm = `${today}/${currentMonth}/${currentYear}`;  
  //console.log(this.atualuser.uid);
  let userId = this.atualuser.uid;
  let materiaMap = {
    "marca": marca,
    "postType": postType,
    "postId": postId,
    "dataFavoritadoEm": dataFavoritadoEm,
    "dominio": window.location.hostname
  }
  console.log(materiaMap);
  await setDoc(doc(this.db, "users",userId),
  { "conteudoFavoritado" : arrayUnion(materiaMap) },
  {merge: true}
  );
  return await this.getFavoritos();

}

async desFavoritar(postId,postType){
  console.log("DESFAVORITAR");
  //console.log(this.atualuser.uid);
  let userId = this.atualuser.uid;
  let removeMateria = null;
  let classId = false;
  if( postType == "author" || postType == "blog"){
    classId = postId;
  }
  AbrilFirebaseInterface.mostraBotFavoritar(true,postType,classId);
  await this.getFavoritos();
  this.userData.conteudoFavoritado.forEach( (materia) => {
    if( materia.postId == postId && materia.postType == postType ){
      removeMateria = materia;
    }
  })

  await setDoc(doc(this.db, "users",userId),
  { "conteudoFavoritado" : arrayRemove(removeMateria) },
  {merge: true}
  );

  return await this.getFavoritos();
  
}

async getFavoritos(){
  let userId = this.atualuser.uid;
  const userSnapshot = await query(this.usersColection, where("uid", "==", userId));
  await getDocs(userSnapshot).then( ( querySnapshot ) => {
    querySnapshot.forEach((doc) => {
    this.userData.conteudoFavoritado = doc.data().conteudoFavoritado;
    });
  });
  return AbrilFirebaseInterface.conteudosFavoritados = this.userData.conteudoFavoritado;
}

async startOntapGoogle() {
  return; /* interrompe onTap */ 
  if(this.ontaptentativas > 3){
    //console.log("DESLOGADO DO GOOGLE");
    //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOntap");
    //return;
  }

  if(!this.hasCrossSession() && customData.activeOntap === "active" &&  customData.showOntap === true){
    this.ontaptentativas = this.ontaptentativas + 1;
    console.log('############### ONTAP ##################');
    if( typeof google === "undefined" ){
      setTimeout(() => {
        this.startOntapGoogle();
      }, "1000");
      return;
    }

    await google.accounts.id.initialize({
        client_id: this.credencialOneTap,
        callback: this.execOnTapLogin.bind(this),
      });

      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          //AbrilScriptsExec.verifyFunctionListLoad();
          this.execAbrilScripts( null, null, "verifyUserCods", null );
          console.log("DESLOGADO DO ONTAP GOOGLE");
          if (notification.isSkippedMoment()) {
            this.createCookieListControl('AbrilOntap');
            console.log("ESCAPADO DO ONTAP GOOGLE");
          }  
          if (notification.isNotDisplayed()) {
            this.createCookieListControl('AbrilOntap');
            console.log("NAO EXIBE MODAL DO ONTAP GOOGLE");
          } 
        }else{
          console.log("EXIBE MODAL DO ONTAP GOOGLE");
        }
    
    });

    }else{
      console.log("############## ONTAP DESATIVADO ##################");
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOntap");
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOntap");
      this.execAbrilScripts( "AbrilBundle.startOntap", "AbrilBundle.startOntap" );
    }
  }

 async execOnTapLogin(response) {
  return; /* cancela onTap */
  console.log(response);
  let dataLogin = '';
  await fetch(this.onTapEndPointWp+response.credential)
    .then((resp)=> {
        return resp.json()
    })
    .then(async(data)=> {
      console.log("Login onTap");
      console.log(data.codStatus);
      if(data.codStatus === 'SU'){
        console.log("email: "+data.valid_email);
        console.log("logando via OnTap");
        this.createCookieListControl('AbrilOntap');
        console.log(data.codStatus);
        this.sendMetricsGA( '', 'Paywall', 'One Tap Login', '' );
        this.userData.tipo_login = "google-onetap";
        this.setOrUpdateUserDataStorage({"tipo_login" : "Google One Tap"});
        await this.loginParceiros(data.valid_email, "OnTap");
        await this.userDataStorage();
      }
    })
    .catch((e)=> {
      console.log('[LOGIN ONTAP][ERRO]', e);
    });
  }
  
  async userDataStorage() {
    if (!this.userData.nomPessoa) {
      return;
    }
    
    let data = {
      nome: this.userData.nomPessoa,
      email: this.userData.email,
      crm: this.userData.crm,
    }
    console.log(this.userData);
    this.setOrUpdateUserDataStorage(data);
    
    if(localStorage.getItem("abrilNotificacoes") === null){
      AbrilNotificacoes.criar(this.userData.crm, false);
    }
  }
  
  setOrUpdateUserDataStorage(dataNew){
    let dataOld = {};

    if(localStorage.getItem("abrilAssetsUser") !== null){
      dataOld = JSON.parse(localStorage.getItem("abrilAssetsUser"));
    }
    
    for (var index in dataNew) {
      if (dataOld.hasOwnProperty(index)) {
        dataOld[index] = dataNew[index];
      } else {
        dataOld[index] = dataNew[index];
      }
    }

    console.log(dataOld);
    
    localStorage.setItem("abrilAssetsUser", JSON.stringify(dataOld));
  }

  clearStorageUser() {
    localStorage.removeItem("abrilAssetsUser");
    localStorage.removeItem("abrilNotificacoes");
    localStorage.removeItem("AbrilProductsUser");
  }
  async checkOnboarding( currentVersion, uid, permission ) {
    console.log("!!!!!!!!  EXECUTA ONBOARRDING  !!!!!!!!!!!!");
    /* FILA EXCUCAO */
    console.log(currentVersion, uid, permission);
    if( !permission ){
      console.log("bundle chamou ONBOARDING sem permissao");
      this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );
      if(typeof construct_alert_usersonly === "function"){
        construct_alert_usersonly(); 
      }
      return;
    }  
    console.log("checkOnboradingVersionVisited 1");
    if( typeof onboarding_versao == "undefined" ){
      console.log("checkOnboradingVersionVisited 1 caiu"); 
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOnboarding");
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
      this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );
      return;
    }
    console.log("checkOnboradingVersionVisited 2");
    if( ! this.checkOnboradingVersionVisited( onboarding_versao, currentVersion) ){
      return;
    }
    console.log("!!!!!!!!  PARA ONBOARRDING 0  !!!!!!!!!!!!");
    AbrilScriptsExec.checkStatusOnboardingListExec("AbrilBundle.startOnboarding");
    if( !AbrilScriptsExec.checkStatusOnboardingListExec("AbrilBundle.startOnboarding") && !AbrilScriptsExec.checkDirectExec("AbrilBundle.startOnboarding")){
    //if( ! await this.checkListExecOnboarding() ){  
      console.log("!!!!!!!!  PARA ONBOARRDING  !!!!!!!!!!!!");
      return;
    }
    this.loadedOnboarding = false;
    /* FILA EXCUCAO */

    if ( typeof activate_onboarding != "undefined" ){
      if( activate_onboarding != "enabled" ){
        return;
      }
    }else{
      return;
    }

    if( permission ){
      if(typeof construct_alert_functionalities === "function"){
        construct_alert_functionalities();
      }
    }

    if( (parseFloat(onboarding_versao) > parseFloat(currentVersion) && onboarding_versao != "" && onboarding_versao != "undefined" && typeof onboarding_versao !== "undefined") || currentVersion == "" || typeof currentVersion == "undefined" ){
      if(typeof onboarding_start_click_handle === "function"){
        await this.setOnboardinVersion(onboarding_versao, uid);
        onboarding_start_click_handle();
        gaSendEvent(
          "",
          "Onboarding",
          "Aberto automaticamente",
          "",
          "" 
        );
      }
      return;     
    }
    //console.log("###### Nao Exibe onboarding: "+onboarding_versao+" ######")

  }

  async setOnboardinVersion(onboarding_versao, uid){
    if( typeof onboarding_versao !== "undefined" && typeof uid !== "undefined"){
      await setDoc(doc(this.db, "users", uid),
      { onboardingVersion : onboarding_versao },
      {merge: true}
      );
        return ;
   }
  }

  async setListExecOnboarding( status = false){
    console.log("!!!!!!!!  this.loadedOnboarding 1" + this.loadedOnboarding + "   !!!!!!!!!!!!");
    if( typeof onboarding_versao == "undefined" || wp_paywall_vars.is_single != 1){
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOnboarding");
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
      this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );
      return this.loadedOnboarding = false;
    }
    console.log("!!!!!!!!  INICIA ONBOARDING " + this.loadedOnboarding + "   !!!!!!!!!!!!");
    return this.loadedOnboarding = status;
  }

  async checkListExecOnboarding( status = false){
    console.log("!!!!!!!!  STATUS ONBOARDIN " + this.loadedOnboarding + "   !!!!!!!!!!!!");
    return this.loadedOnboarding;
  }

  async checkOnboradingVersionVisited( onboarding_versao, currentVersion){
    if( (parseFloat(onboarding_versao) > parseFloat(currentVersion) && onboarding_versao != "" && onboarding_versao != "undefined" && typeof onboarding_versao !== "undefined") || currentVersion == "" || typeof currentVersion == "undefined" ){
      //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
      this.execAbrilScripts( null, "AbrilBundle.startOnboarding" );
      return true;    
    }
    this.loadedOnboarding = false;
    //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOnboarding");
    //AbrilScriptsExec.setLoadStatus("AbrilBundle.startOnboarding");
    this.execAbrilScripts( "AbrilBundle.startOnboarding", "AbrilBundle.startOnboarding" );
    return false;
  }

  async checkLinking(){
    let showInPage = false;
    if( wp_paywall_vars.is_single == 1){
      showInPage = true;
    }

    if( this.getCookie( 'AbrilLinkingSwg') || this.indGoogleSubLinking == "S" || this.indGoogleSwg == "S" ){
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startLinking");
      this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking", null, null, "next" );
      return;
    }
    let blackList = ["login","ofertas","assinar","meu-curso"];
    if( this.escapeBySlug( window.location.href, blackList ) ){
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startLinking");
      this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking", null, null, "next" );
      return;
    }
  
    if( !wp_paywall_vars.subscription_linking || showInPage == false){
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startLinking");
      this.execAbrilScripts( "AbrilBundle.startLinking","AbrilBundle.startLinking", null, null, "next" );
      return;
    } 

  }

  async setListExecLinking(){
    //await this.checkLinking();
    console.log("@@@@@@@@@@@@@@@@@@ CHAMOU O LINKING @@@@@@@@@@@@@@@@");
    this.linkingSwg();
    return true;
  } 

  async checkOntap(){
    let showInPage = false;
    if( wp_paywall_vars.is_single == 1){
      showInPage = true;
    }

    if( this.getCookie( 'AbrilOntap')  || showInPage == false ){
      //AbrilScriptsExec.removeFunctionList("AbrilBundle.startOntap");
      this.execAbrilScripts( "AbrilBundle.startOntap" );
      return;
    }
  }

  async setListExecOntap(){
    this.startOntapGoogle();
    return true;
  }

  createCookieListControl(name){
    var d = '';
    d = new Date();
    d.setTime( d.getTime() + (1000*60*60*24)) ;
    this.setCookie( name , true, d );
    //if( localStorage.getItem('AbrilOntap') == null ){
      //localStorage.setItem('AbrilOntap', true);
    //}
  }

  checkCookieListControl(name,func){
    /*if( localStorage.getItem(name) ){
      AbrilScriptsExec.removeFunctionList(func);
      return false;    
    }*/
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) {
          return true;
        }
      }
   
    return false;
  }

  execAbrilScripts( remove = null, load = null, verify = null, erase = null, next = null, autoexec = null ){
    if( typeof AbrilScriptsExec == 'undefined' ){
      console.log("Canela Fila");
      return;
    }
    if( remove != null ){
      AbrilScriptsExec.removeFunctionList(remove);
    } 
    if( load != null ){
      AbrilScriptsExec.setLoadStatus(load);
    } 
    if( verify != null ){
      AbrilScriptsExec.verifyFunctionListLoad();
    }     
    if( erase != null ){
      AbrilScriptsExec.eraseCookieList(erase);
    }  
    if( next != null ){
      AbrilScriptsExec.execNextList();
    }  
    if( autoexec != null ){
      AbrilScriptsExec.status(autoexec);
    }    
    return;
  }

  execAbrilScriptsDirect(func){
    if( AbrilScriptsExec.checkDirectExec(func) ){
      return true;
    }
    return false;
  }

  /*
  checkOntapVisited(){
    if( localStorage.getItem('AbrilOntap') ){
      AbrilScriptsExec.removeFunctionList("AbrilBundle.startOntap");
      return false;    
    }
    return true;
  }


*/

}
